import React, { FC, Suspense } from 'react'

import { useTypedSelector } from '@hooks/common/useTypedSelector'

import { lazyImport } from '@utils/lazyImport'

const { PrivacyPolicy } = lazyImport(
  () =>
    import(
      /*webpackChunkName: 'privacy-policy'*/ '@components/Overlays/PrivacyPolicy/PrivacyPolicy'
    ),
  'PrivacyPolicy'
)

export const LazyPrivacyPolicy: FC = () => {
  const isOpened = useTypedSelector(
    (state) => state.overlays.privacyPolicy.isOpened
  )

  return <Suspense fallback={null}>{isOpened && <PrivacyPolicy />}</Suspense>
}
